export default __webpack_public_path__ + "static/media/AnimalGame_10.ade91233.png";